document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("benefits");

  if(!container) {
    return
  }

  let position = 0;
  let itemWidth = document.getElementById("benefits").querySelector('.benefits__col').scrollWidth; // Width of each item in pixels
  let gap = 20;
  let speed = 1;  // Adjust this value to control the speed (higher value = faster scroll)

  // Calculate the total width of the benefits content
  const totalWidth = container.children.length * (itemWidth + gap); // 40px gap added
  container.style.width = `${totalWidth}px`;

  function moveMarquee() {
      position -= speed; // Adjust speed by changing the value of 'speed'
      container.style.transform = `translateX(${position}px)`;

      if (position <= -(itemWidth + gap)) { // 40px gap added
          position = 0;
          container.appendChild(container.firstElementChild);
          container.style.transform = `translateX(${position}px)`;
      }

      requestAnimationFrame(moveMarquee);
  }

  moveMarquee();
});
